import useTranslationAndTypograph from 'hooks/useTranslationAndTypograph';
import { useRouter } from 'next/router';
import React from 'react';

import { FormattedPrice } from 'components/domains/payments/FormattedPrice';

import { useAppSelector } from 'redux-store';
import type { ProductType } from 'redux-store/slices/products/types';

interface Props {
  selectedPlan?: ProductType;
  isRu?: boolean;
}

function getDescriptionWithPrice(
  selectedPlan?: ProductType,
): JSX.Element | null {
  const priceData = selectedPlan?.prices[0];

  if (!priceData) {
    return null;
  }

  const { interval, interval_count, price, currency } = priceData;
  const formattedPrice = (
    <FormattedPrice price={price.toFixed(2)} currency={currency} />
  );

  if (interval === 'lifetime') {
    return (
      <>
        One-time payment. No renewal. Questions?{' '}
        <a href="mailto:support@welltory.com">support@welltory.com</a>
      </>
    );
  }

  if (interval === 'month') {
    const intervalMonths = interval_count && interval_count > 1;
    return (
      <>
        Auto-renews at the regular price unless canceled.
      </>
    );
  }

  if (interval === 'year') {
    return (
      <>
        Auto-renews at the regular price unless canceled.
      </>
    );
  }

  return null;
}

export default function ButtonDescription({
  selectedPlan,
  isRu,
}: Props): JSX.Element {
  const router = useRouter();
  const buttonTextQuery = router.query.button_text as string | undefined;
  const { productPage } = useAppSelector(state => state.products);
  const {
    isAuthenticated,
    profile: { email },
  } = useAppSelector(state => state.profile);
  const t = useTranslationAndTypograph();
  let buttonDescription = (
    <>{t('Billed annually auto-renews unless cancelled')}</>
  );

  if (isRu) {
    buttonDescription = (
      <>
        {t(
          'One-time-payment subscriptions cant be cancelled renewed transferred nor refunded',
        )}
      </>
    );
  }

  if (selectedPlan && selectedPlan.prices[0].interval === 'lifetime') {
    buttonDescription = (
      <>
        {t(
          'One-time-payment subscriptions cant be cancelled renewed transferred nor refunded',
        )}
      </>
    );
  } else if (selectedPlan && selectedPlan.prices[0].interval === 'month') {
    buttonDescription = <>{t('Billed monthly auto-renews unless cancelled')}</>;
  }

  if (buttonTextQuery) {
    buttonDescription =
      getDescriptionWithPrice(selectedPlan) ?? buttonDescription;
  }

  if (productPage === 'gift') {
    if (isAuthenticated) {
      buttonDescription = (
        <>
          {t('We’ll email you a gift code and all the instructions to')} {email}
        </>
      );
    } else {
      buttonDescription = (
        <>
          {t(
            'We’ll send a gift code and all the instructions to the email you use to log in',
          )}
        </>
      );
    }
  }

  return buttonDescription;
}
